export default function EMProductController(
  $rootScope,
  confirmDialog,
  ssDialogService,
  loaderService,
  alerts,
  vmSharedModelService,
  addVendorProductDialog,
) {
  const vm = this;

  vm.cssPrefix = vm.isEdit ? 'dialog-' : '';
  vm.canEditProduct = true;
  vm.canDeleteProduct = true;

  vm.handleExpandClick = _handleExpandClick;
  vm.handleEditProduct = _handleEditProduct;
  vm.handleDeleteProduct = _handleDeleteProduct;
  vm.handleSelectProduct = _handleSelectProduct;

  activate();
  /** *****************************************
   * Event Handlers
   */

  function _handleExpandClick() {
    if (vm.canExpand) {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleEditProduct($event) {
    vm.product.vendorId = vm.vendorId;
    ssDialogService.dialogs.enterpriseModeling.editProductDialog = ssDialogService.alert(
      addVendorProductDialog.getOptions($event, {
        product: vm.product,
        vendorId: vm.vendorId,
        addCallback: null
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editProductDialog);
  }

  function _handleDeleteProduct($event) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Product?',
        message: `Are you sure you want to delete the Product, "${vm.product.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteProductDialog();
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return vmSharedModelService.deleteProduct(vm.product.productId).then(() => {
      alerts.success(`The Product "${vm.product.name}" has successfully been deleted.`);
      _closeDeleteProductDialog();
      vm.deleteCallback(vm.product);
    }).catch(() => {
      alerts.error('An error occurred while deleting the Product.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _closeDeleteProductDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }

  function activate() {
    vm.displayProductCheckBox = vm.functionVendorId || (!vm.functionVendorId && !vm.isVendorDialog);
  }

  function _handleSelectProduct() {
    if (vm.product.isSelected === true) {
      $rootScope.$broadcast('selectVendorProduct', { vendorId: vm.vendorId });
    }
  }
}

EMProductController.$inject = [
  '$rootScope',
  'confirmDialog',
  'ssDialogService',
  'loaderService',
  'alerts',
  'vmSharedModelService',
  'addVendorProductDialog',
];
